import type { TFunction } from 'i18next';

/**
 * The header's translated copy, from whichever `t` the caller has: the SPA Menu's (useTranslation)
 * or the server's (rsc/i18n.ts, for rsc/chrome/PublicHeader). Views take these as props.
 *
 * Keys are spelled out in full at each `t()` call so `npm run i18n:check` can find them.
 */

/** The header's page links (HeaderNavLinks). */
export interface HeaderNavStrings {
    /** The nav landmark's name. */
    label: string;
    explore: string;
    library: string;
}

/** The signed-out Sign in button: visible text and its accessible name. */
export interface SignInStrings {
    text: string;
    label: string;
}

/** Everything the header shows, for the SPA Menu and the RSC PublicHeader. */
export interface HeaderStrings {
    nav: HeaderNavStrings;
    signIn: SignInStrings;
    logoAlt: string;
    /** The menu toggle's accessible name, closed and open. */
    menu: string;
    closeMenu: string;
    navigationMenuLabel: string;
    partnerLogosLabel: string;
}

export function headerNavStrings(t: TFunction): HeaderNavStrings {
    return {
        label: t('header.nav.label'),
        explore: t('header.nav.explore'),
        library: t('header.nav.library'),
    };
}

export function signInStrings(t: TFunction): SignInStrings {
    return {
        text: t('header.signIn'),
        label: t('header.signInLabel'),
    };
}

export function headerStrings(t: TFunction): HeaderStrings {
    return {
        nav: headerNavStrings(t),
        signIn: signInStrings(t),
        logoAlt: t('header.logoAlt'),
        menu: t('header.menu'),
        closeMenu: t('header.closeMenu'),
        navigationMenuLabel: t('header.navigationMenuLabel'),
        partnerLogosLabel: t('header.partnerLogosLabel'),
    };
}
